import axios from "axios";

export default {
    getTextsResultsByCompanyID(_, params) {
        return axios.post('/api/su1result/gettextsresultsbycompanyid', params, { withCredentials: true });
    },
    su1Pie(_, params) {
        return axios.post('/api/su1result/getglobalgoalsresultcountsbycompanyid', params, { withCredentials: true });
    },
    su1SubColumn(_, params) {
        return axios.post('/api/su1result/getsubgoalsresultcountsbycompanyid', params, { withCredentials: true });
    },
    greenDeal(_, params) {
        return axios.post('/api/su1result/getgreendealsresultcountsbycompanyid', params, { withCredentials: true });
    },
    wordCloud(_, params) {
        const minutesToMs = (min) => {
            if (min) {
                return min * 60 * 1000;
            } else {
                return 10000;
            }
        };

        return axios.post('/api/su1result/getmostwrittenwordsbycompanyid', params, { responseType: 'blob', withCredentials: true, timeout: minutesToMs(5) });
    },
    su1TotalCompleted(_, params) {
        return axios.post('/api/survey/su1/getsurveyinfosbysurveyid', params, { withCredentials: true });
    },
    setSelectedSurveyID({ commit }, value) {
        commit('setSelectedSurveyID', value);
    },
    getSU2SurveyResults(_, params) {
        return axios.post('api/su2result/getsu2textresults', params, { withCredentials: true });
    },
    getSu2SurveyResultsForExcel(_, params) {
        return axios.post('/api/su2result/getsu2surveyresultsforexcel', params, { withCredentials: true });
    },
    getInternalStakeholderAverageAnswers(_, params) {
        return axios.post('/api/survey/su2/getsu2answersaverage', params, { withCredentials: true });
    },
    getMaterialityMatrixData(_, params) {
        return axios.post('/api/survey/su2/getmaterialitymatrix', 
            params, 
            { 
                withCredentials: true, 
                headers: {
                    'Accept-Language': params.language,
                } 
            }
        );
    },
    uploadReportGraph(_, params) {
        return axios.post('/api/myreport/uploadmyreportgraph', params, { withCredentials: true });
    },
    getLastSU1Survey(_, params) {
        return axios.post('/api/survey/su1/getlastsurvey', params, { withCredentials: true });
    },
    getLastSU2Survey(_, params) {
        return axios.post('/api/survey/su2/getlastsurvey', params, { withCredentials: true });
    }
}
